import React, { use } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { Navigate, useLocation } from 'react-router-dom';
import Background from 'assets/background-image.svg?react';
import Logo from 'assets/logo.svg?react';
import PopUp from 'shared/components/pop-up/pop-up';
import Routes from 'shared/enums/routes';
import AuthProviderContext from 'shared/features/auth/authentication/providers/contexts/auth-provider-context';

import LoginForm from 'features/login/components/login-form/login-form';
import styles from './login.module.scss';

const Login = (): React.JSX.Element => {
  const auth = useAuth();
  const { logout } = use(AuthProviderContext);
  const { t } = useTranslation('login');
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const shouldShowNoAccessScreen = searchParams.get('noAccess') === 'true';

  if (auth.isLoading) {
    return <></>;
  }

  if (auth.isAuthenticated && !shouldShowNoAccessScreen) {
    return <Navigate to={Routes.Default} />;
  }

  return (
    <div className={styles.loginContainer}>
      <div className={styles.imageContainer}>
        <Background className={styles.backgroundImage} />
        <Logo className={styles.logo} />
      </div>
      {!auth.isAuthenticated && (
        <div className={styles.boxContainer}>
          <LoginForm />
        </div>
      )}
      <PopUp
        isOpen={shouldShowNoAccessScreen}
        title={t('noAccessTitle')}
        body={t('noAccessBody')}
        primaryButtonText={t('noAccessPrimaryButtonText')}
        handleOnClose={logout}
        primaryButtonAction={logout}
      />
    </div>
  );
};

export default Login;
